module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/sophia-2ea31928c6ab9fb96d6209e5d53b1cbf.jpg";